export default __webpack_public_path__ + "static/media/arrowRightFill.2c0013b5.svg";